import { Component, type ErrorInfo, type ReactNode } from 'react';

interface Props {
  children: ReactNode;
}

interface State {
  error: Error | null;
}

/**
 * アプリ全体の最後の砦。 render 中の想定外例外を白画面ではなく
 * 「再読み込み」導線付きの画面に落とす。 wasm ロード失敗など個別に扱える
 * ものは各画面の fallback で拾い、 ここはそれをすり抜けたクラッシュ用。
 */
export class ErrorBoundary extends Component<Props, State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  componentDidCatch(error: Error, info: ErrorInfo): void {
    console.error('Uncaught error', error, info.componentStack);
  }

  render(): ReactNode {
    if (this.state.error) {
      return (
        <div className="error-boundary" role="alert">
          <h1>問題が発生しました</h1>
          <p>予期しないエラーで画面を表示できませんでした。</p>
          {/* スマホだと console を開けないので、 画面に出して報告できるようにする。 */}
          <p className="error-boundary-detail">
            {this.state.error.message || String(this.state.error)}
          </p>
          <button type="button" onClick={() => window.location.reload()}>
            再読み込み
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
